<div class="line-scope-wrapper" appUserManual [userManualKey]="'procurement-package-scope-of-work'">
  <div class="csa-table">
    <h3>LINE tags grouped by commissioning package</h3>

    <div class="filter">
      <span>Filter:</span>
      <div class="filter-field-wrapper">
        <mat-form-field appearance="outline" class="filter-field">
          <mat-label>Filter</mat-label>
          <input matInput [(ngModel)]="filterText" (keyup)="onFilterKeyup()" placeholder="Tag / Checksheet / Commissioning package / ID" />
          <button *ngIf="filterText" mat-icon-button matSuffix aria-label="Clear filter" (click)="clearFilter()">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <div class="sow-filter-actions">
          <span class="toggle-text" *ngIf="hideUnassigned">Unassigned only</span>
          <span class="toggle-text" *ngIf="!hideUnassigned">All items</span>
          <button
            type="button"
            mat-raised-button
            class="aker-context-button sow-toggle-btn"
            (click)="toggleHideUnassigned()"
            [attr.aria-pressed]="hideUnassigned"
            matTooltip="{{ hideUnassigned ? 'Unassigned only (click to show all)' : 'Show only unassigned' }}"
          >
            <mat-icon>{{ hideUnassigned ? 'filter_alt' : 'filter_alt_off' }}</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <mat-accordion [multi]="true">
      <mat-expansion-panel *ngFor="let group of lineAssignmentsGroupedByCommissioningPackage" [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ group.commissioningPackageNumber }}</mat-panel-title>
          <mat-panel-description>{{ group.assignments.length }} checksheets</mat-panel-description>
        </mat-expansion-panel-header>

        <table mat-table [dataSource]="group.assignments">
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef></th>
            <td mat-cell *matCellDef="let assignment">
              <mat-checkbox (change)="onSelectAssignment(assignment, $event)" [checked]="isAssignmentSelected(assignment)"></mat-checkbox>
            </td>
          </ng-container>
          <ng-container matColumnDef="tag">
            <th mat-header-cell *matHeaderCellDef>Tag</th>
            <td mat-cell *matCellDef="let assignment">{{ assignment.tagNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="checksheet">
            <th mat-header-cell *matHeaderCellDef>Check sheet</th>
            <td mat-cell *matCellDef="let assignment">{{ assignment.checkSheetNumber }}</td>
          </ng-container>
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let assignment">{{ assignment.status }}</td>
          </ng-container>
          <ng-container matColumnDef="assignedCount">
            <th mat-header-cell *matHeaderCellDef>Assigned</th>
            <td mat-cell *matCellDef="let assignment">
              <span class="assigned-pill" [ngClass]="getAssignedCountPillClass(assignment)">
                {{ getAssignedCountLabel(assignment) }}
              </span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="lineAssignmentColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: lineAssignmentColumns"></tr>
        </table>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
